import Typography from 'carbon-react/lib/components/typography';

interface ActionBarTitleProps {
  title?: string;
}
export function ActionBarTitle({ title }: ActionBarTitleProps) {
  return <Typography variant="h1">{title}</Typography>;
}
